<template>
  <div>
    <el-dialog
      title="编辑申报评估排名"
      :visible.sync="isShow"
      width="780px"
      :before-close="handleCloseDialog"
    >
      <div class="sort-wrapper" v-if="!isLoading && formatedList.length">
        <vue-draggable v-model="formatedList" class="s-content">
          <div
            class="draggable-item"
            :class="{'suc-item': item.auditState === 1, 'warn-item': item.auditState === 3, 'err-item': item.auditState === 2}"
            v-for="(item, index) in formatedList"
            :key="item.uuid"
          >
            第{{ index + 1 }}名：{{ item.youthShortName }}&nbsp;({{ item.auditState | auditStateFilters}})
          </div>
        </vue-draggable>
      </div>
      <div class="sort-wrapper empty-wrapper" v-if="isLoading">
        <p>数据努力加载中...</p>
      </div>
      <div class="sort-wrapper" v-if="!isLoading && !formatedList.length">
        <yioks-empty :whiteBg="true" tips="仅支持对已经完成初审流程的申报单位进行排名。请先完成对申报单位的评估。"></yioks-empty>
      </div>
      <div slot="footer" class="footer-btns">
        <el-button type="primary" @click="handleConfirmAction"
          >保存排名</el-button
        >
        <el-button type="danger" @click="handleCancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vuedraggable from "vuedraggable";
import { putSortedOrg, loadUnSortYouthListForAdmin } from "@/api/performance";
import { auditStateFilters } from "@/assets/js/yioksFilters";

export default {
  components: {
    "vue-draggable": vuedraggable,
    "yioks-empty": () => import("@/components/YioksEmpty"),
  },

  props: {
    isShow: {
      type: Boolean,
      required: true,
    },

    infoList: {
      type: Array,
      required: true,
    },

    stageUuid: {
      type: String,
      required: true,
    },

    groupUuid: {
      type: String,
      required: true,
    },

    propsType: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      formatedList: [],
      unSubmitedList: [], // 临时存储未排名（未提交或者审核完成的单位列表，需回传给后台方便排序）
      isLoading: false,
    };
  },

  filters: {
    auditStateFilters,
  },

  async created() {
    await this.loadSourceYouthList();
  },

  methods: {
    handleCloseDialog() {
      this.setStatus(false);
    },

    // 设置弹窗状态
    setStatus(flag) {
      this.$emit("update:isShow", flag);
    },

    // 提交排名
    handleConfirmAction() {
      let allList = this.formatedList.concat(this.unSubmitedList);

      allList = allList.map((item, i) => {
        const {
          uuid: youthUuid,
          stageApplyType,
          stageUuid,
          rankingUuid: uuid,
          ...other
        } = item;
        return {
          youthUuid,
          stageApplyType,
          stageUuid,
          // uuid,
          sort: i + 1,
        };
      })

      putSortedOrg(allList)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          this.$emit("callback", true);
          this.setStatus(false);
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    handleCancel() {
      this.setStatus(false);
    },
    // 获取全部 待排名 单位列表；（包含已排名、未排名、不允许排名单位；）
    async loadSourceYouthList() {
      const paramsData = {
        groupUuid: this.groupUuid,
        stageUuid: this.stageUuid,
        type: this.propsType,
      };

      this.isLoading = true;
      try {
        const res = await loadUnSortYouthListForAdmin(paramsData);

        this.isLoading = false;
        if (res.length) {
          let submitedList = [],
            unSubmitedList = []; // 分离已提交且审核完成的单位；进行排序操作
          res.forEach((e) => {
            if (e.audit && e.submit) {
              submitedList.push(e);
            } else {
              unSubmitedList.push(e);
            }
          });
          this.unSubmitedList = unSubmitedList;
          let sortedList = [],
            unSortList = [];
          submitedList.forEach((item) => {
            if (item.adminSort !== undefined && item.adminSort !== 0) {
              sortedList.push(item);
            } else {
              unSortList.push(item);
            }
          });
          // 对已经排名的单位按排名排序，然后追加可排名而未参与排名的单位
          sortedList.sort((a, b) => {
            return a.adminSort - b.adminSort;
          });

          this.formatedList = sortedList.concat(unSortList);

        } else {
          this.isLoading = false;
          this.formatedList = [];
        }
      } catch (err) {
        console.error("err", err);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.s-content
  display flex
  border 1px solid #4cd964
  border-radius 3px
  padding 10px
  flex-wrap wrap
  box-sizing border-box
  .draggable-item
    background-color #4cd964
    color #fff
    font-size 18px
    padding 10px 20px
    margin 5px
    border-radius 5px
    cursor pointer
    width calc(50% - 10px)
    box-sizing border-box
.footer-btns
  width 45%
  margin 0 auto
  display flex
  justify-content space-around


.empty-wrapper
  height: 180px
  font-size: 1.4em
  display: flex
  justify-content: center
  align-items: center
</style>
